import maintainerApi from '@/api/maintainer'

export const SET_MAINTAINERS = 'SET_MAINTAINERS'
export const CLEAR_MAINTAINERS = 'CLEAR_MAINTAINERS'
export const ADD_NEW_MAINTAINER = 'ADD_NEW_MAINTAINER'
export const UPDATE_MAINTAINER = 'UPDATE_MAINTAINER'
export const REMOVE_MAINTAINER = 'REMOVE_MAINTAINER'
export const SET_SELECTED_MAINTAINER = 'SET_SELECTED_MAINTAINER'
export const SET_SELECTED_MAINTAINER_PERIODS = 'SET_SELECTED_MAINTAINER_PERIODS'
export const CLEAR_SELECTED_MAINTAINER_PERIODS = 'CLEAR_SELECTED_MAINTAINER_PERIODS'
export const CLEAR_SELECTED_MAINTAINER = 'CLEAR_SELECTED_MAINTAINER'
export const SET_SELECTED_PERIOD = 'SET_SELECTED_PERIOD'
export const CLEAR_SELECTED_PERIOD = 'CLEAR_SELECTED_PERIOD'
export const ADD_PERIOD_TO_SELECTED_MAINTAINER = 'ADD_PERIOD_TO_SELECTED_MAINTAINER'
export const UPDATE_PERIOD_FROM_SELECTED_MAINTAINER = 'UPDATE_PERIOD_FROM_SELECTED_MAINTAINER'
export const REMOVE_PERIOD_FROM_SELECTED_MAINTAINER = 'REMOVE_PERIOD_FROM_SELECTED_MAINTAINER'
export const SET_SELECTED_MAINTAINER_CLIENTS = 'SET_SELECTED_MAINTAINER_CLIENTS'
export const ADD_CLIENT_TO_MAINTAINER = 'ADD_CLIENT_TO_MAINTAINER'
export const REMOVE_CLIENT_FROM_MAINTAINER = 'REMOVE_CLIENT_FROM_MAINTAINER'
export const SHOW_CLIENT_EDIT_ICON = 'SHOW_CLIENT_EDIT_ICON'
export const HIDE_CLIENT_EDIT_ICON = 'HIDE_CLIENT_EDIT_ICON'
export const TOGGLE_CLIENT_IS_EDITING = 'TOGGLE_CLIENT_IS_EDITING'
export const UPDATE_CLIENT_IES_ALIAS = 'UPDATE_CLIENT_IES_ALIAS'

const state = {
  maintainers: {
    accounts: [],
    total: {}
  },
  selectedMaintainer: {
    id: 0,
    idModelContract: 0,
    idContractStage: 0,
    idSalesforce: '',
    nameSalesforce: '',
    codMaintainer: '',
    cnpj: '',
    nameBilling: '',
    nameTypeForm: '',
    periods: [],
    clients: [],
    active: true,
    tenantAlias: '',
    integrationDate: ''
  },
  selectedPeriod: {
    id: null,
    idaccount: null,
    idaccounttype: null,
    startperiod: '',
    endperiod: '',
    licenses: null,
    active: null,
    codcontract: ''
  }
}
const getters = {
  getterMaintainers: state => state.maintainers,
  getterSelectedMaintainer: state => state.selectedMaintainer,
  getterSelectedPeriod: state => state.selectedPeriod
}
const mutations = {
  [SET_MAINTAINERS] (state, values) {
    state.maintainers = values
  },
  [CLEAR_MAINTAINERS] (state) {
    state.maintainers = {
      accounts: [],
      total: {}
    }
  },
  [ADD_NEW_MAINTAINER] (state, values) {
    state.maintainers.accounts.push(values)
  },
  [UPDATE_MAINTAINER] (state, values) {
    const updatedMaintainer = state.maintainers.accounts.find((val) => {
      return val.id === values.id
    })
    Object.assign(updatedMaintainer, values)
  },
  [REMOVE_MAINTAINER] (state, values) {
    state.maintainers.accounts = state.maintainers.accounts.filter((val) => {
      return val.id !== values.id
    })
  },
  [SET_SELECTED_MAINTAINER] (state, value) {
    state.selectedMaintainer = value
  },
  [CLEAR_SELECTED_MAINTAINER] (state) {
    state.selectedMaintainer = {
      id: 0,
      idModelContract: 0,
      idContractStage: 0,
      idSalesforce: '',
      nameSalesforce: '',
      codMaintainer: '',
      cnpj: '',
      nameBilling: '',
      nameTypeForm: '',
      periods: [],
      clients: [],
      active: true
    }
  },
  [SET_SELECTED_MAINTAINER_PERIODS] (state, values) {
    state.selectedMaintainer.periods = values
  },
  [CLEAR_SELECTED_MAINTAINER_PERIODS] (state) {
    state.selectedMaintainer.periods = []
  },
  [ADD_PERIOD_TO_SELECTED_MAINTAINER] (state, values) {
    state.selectedMaintainer.periods = [...state.selectedMaintainer.periods, values]
  },
  [UPDATE_PERIOD_FROM_SELECTED_MAINTAINER] (state, values) {
    const updatedPeriod = state.selectedMaintainer.periods.find((val) => {
      return val.id === values.id
    })
    Object.assign(updatedPeriod, values)
  },
  [REMOVE_PERIOD_FROM_SELECTED_MAINTAINER] (state, values) {
    state.selectedMaintainer.periods = state.selectedMaintainer.periods.filter((val) => {
      return val.id !== values.periodId
    })
  },
  [SET_SELECTED_PERIOD] (state, values) {
    Object.assign(state.selectedPeriod, values)
  },
  [CLEAR_SELECTED_PERIOD] (state) {
    state.selectedPeriod = {
      id: null,
      idaccount: null,
      idaccounttype: null,
      startperiod: '',
      endperiod: '',
      licenses: null,
      active: false,
      codcontract: ''
    }
  },
  [ADD_CLIENT_TO_MAINTAINER] (state, values) {
    state.selectedMaintainer.clients.push(values)
  },
  [REMOVE_CLIENT_FROM_MAINTAINER] (state, values) {
    const clientIndex = state.selectedMaintainer.clients.findIndex((val) => {
      return val.clientid === values.clientid
    })

    if (clientIndex > -1) {
      state.selectedMaintainer.clients.splice(clientIndex, 1)
    }
  },
  [SHOW_CLIENT_EDIT_ICON] (state, values) {
    var client = state.selectedMaintainer.clients.find((client) => {
      return client.clientid === values
    })

    client.showEditIcon = true
  },
  [HIDE_CLIENT_EDIT_ICON] (state, values) {
    var client = state.selectedMaintainer.clients.find((client) => {
      return client.clientid === values
    })

    client.showEditIcon = false
  },
  [TOGGLE_CLIENT_IS_EDITING] (state, values) {
    var client = state.selectedMaintainer.clients.find((client) => {
      return client.clientid === values
    })

    client.isEditing = !client.isEditing
  },
  [UPDATE_CLIENT_IES_ALIAS] (state, values) {
    var client = state.selectedMaintainer.clients.find((client) => {
      return client.clientid === values.clientId
    })

    client.ies_alias = values.iesAlias
  }
}
const actions = {
  actionGetMaintainers (_, params) {
    return maintainerApi.getMaintainers(params)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.status === 401 ? e.data.error : e.data)
      })
  },
  actionGetOneMaintainer ({ commit }, id) {
    return maintainerApi.getOneMaintainer(id)
      .then((response) => {
        commit(SET_SELECTED_MAINTAINER, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionRegisterMaintainer (_, params) {
    return maintainerApi.registerMaintainer(params)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionUpdateMaintainer (_, params) {
    return maintainerApi.updateMaintainer(params.id, params.data)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionDeleteMaintainer (_, id) {
    return maintainerApi.deleteMaintainer(id)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionGetMaintainerPeriods ({ commit }, id) {
    return maintainerApi.getMaintainerPeriods(id)
      .then((response) => {
        commit(SET_SELECTED_MAINTAINER_PERIODS, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.responde.data)
      })
  },
  actionAddMaintainerPeriod ({ commit }, params) {
    return maintainerApi.addMaintainerPeriod(params)
      .then((response) => {
        commit(ADD_PERIOD_TO_SELECTED_MAINTAINER, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionEditMaintainerPeriod ({ commit }, params) {
    return maintainerApi.editMaintainerPeriod(params)
      .then((response) => {
        commit(UPDATE_PERIOD_FROM_SELECTED_MAINTAINER, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionDeleteMaintainerPeriod ({ commit }, params) {
    return maintainerApi.deleteMaintainerPeriod(params)
      .then((response) => {
        commit(REMOVE_PERIOD_FROM_SELECTED_MAINTAINER, params)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionLinkClientToMaintainer (_, params) {
    return maintainerApi.linkClientToMaintainer(params)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionUnlinkClientFromMaintainer (_, params) {
    return maintainerApi.unlinkClientFromMaintainer(params)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
